<!-- Created by Daniil V. on 20/4/2021.-->
<!-- Copyright © 2021 SEVEN. All rights reserved.-->
<div>
  <img [src]="imgSrc" alt="tt-image">
  <div class="m-t-16 m-b-8" fxLayout="row" fxLayoutAlign="end center">
    <curr-button (click)="closeDialog()" [variant]="'text'">CLOSE</curr-button>
  </div>
</div>